export default "__VITE_ASSET__BLAT5C6h__"